export const ArtistsAboutId = 'artists-about';
